import type { QueryClient } from "@tanstack/react-query";

/**
 * Invalidate and optionally refetch parties list and question options queries.
 * Uses predicate matching so we hit the actual query keys produced by the generated
 * client (createQueryKey returns [{ _id, baseUrl, ... }], not a string array).
 * Call after party upload, party create/update, or question option add/remove
 * so the dashboard parties list and Questions column stay in sync.
 */
export async function invalidatePartiesAndQuestionOptions(
  queryClient: QueryClient,
  options?: { refetch?: boolean },
): Promise<void> {
  const predicate = (query: { queryKey: readonly unknown[] }) => {
    const first = query.queryKey[0] as { _id?: string } | undefined;
    return (
      first?._id === "getParties" ||
      first?._id === "getParty" ||
      first?._id === "getQuestionOptions"
    );
  };
  await queryClient.invalidateQueries({ predicate });
  if (options?.refetch) {
    await queryClient.refetchQueries({ predicate });
  }
}
